module.exports = __webpack_public_path__ + "media/andre2.f580a8f9.mp3";